import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoginForm from '../forms/LoginForm';
import IppButtons, { IPP_BUTTONS_STYLE } from '../ipp/IppButtons';
import styles from '../../css/components/headers/extendedLogin.css';
import { withIppButtons } from '../../helpers/ipp-buttons';
import { cookieExist, getCookieValue } from '../../helpers/browser-cookies';
import { COOKIE_NOTIFICATION_NAME } from '../../helpers/cookie-overlay';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import { AppContext } from '../../Store';
import { useTranslation } from 'react-i18next';
import Modal from '../modals/Modal';
import PasswordForgottenStepOne from '../password-forgotten/Step1';

function ExtendedLogin( {
	handleIppLinkClick = () => {},
	showExtendedByDefault = true,
	showRememberMe = false,
	showForgotPassword = false,
	isTabbed = false,
	formWrapperClassName = '',
	forgotPasswordLink = null,
}) {
	const { t, i18n } = useTranslation('translation');
	const [state, dispatch] = useContext(AppContext);

	const [showExtendedOnSmallScreens, setShowExtendedOnSmallScreens] = useState(showExtendedByDefault);
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const showPassfForgottenOverlay = state.showForgotPWOverlay;

	const wrapperClassNames = `${styles.extendedLoginWrapper} ${showExtendedOnSmallScreens ? styles.showExtended : styles.hideExtended}`;
	const ippLinkExist = onelpsParams.ippLinks.length > 0;

	const gameId = onelpsParams.gameId;

	const getIppLoginCaption = () =>
		i18n.exists(`loginForm.ippCaption.${gameId}`) ?
			t(`loginForm.ippCaption.${gameId}`) :
			t('loginForm.ippCaption.generic');

	useEffect(() => {
		dispatch({ type: 'SET_REMEMBER_USER', payload: onelpsParams.loginForm.preselectRememberMe });
	}, [dispatch, onelpsParams.loginForm.preselectRememberMe]);

	return (
		<div className={wrapperClassNames}>
			<div
				data-testid="loginWrapper"
				className={styles.loginWrapper}
			>
				<div className={styles.inputWrapper}>
					<LoginForm
						playerIdentifierInputId="page_login_always-visible_input_player-identifier"
						passwordInputId="page_login_always-visible_input_password"
						buttonId="page_login_always-visible_button_login"
						wrapperClassName={formWrapperClassName}
						isTabbed={isTabbed}
					>
						{onelpsParams.loginForm.showIpp && ippLinkExist && (
							<div className={styles.ippWrapper}>
								<IppButtons 
									cookieNotificationValue={cookieExist(COOKIE_NOTIFICATION_NAME) ? getCookieValue(COOKIE_NOTIFICATION_NAME) : '0'}
									onLinkClick={(e, link) => handleIppLinkClick(e, link, true)}
									style={IPP_BUTTONS_STYLE.LOGIN_FORM}
									captionText={getIppLoginCaption()}
									captionPosition={onelpsParams.loginForm.ippCaptionPosition}
								/>
							</div>
						)}
					</LoginForm>
					<span className={`${styles.moreOptions} ${isTabbed && styles.tabbedForm} ${ippLinkExist && styles.extraTopMargin }`}>
						{showRememberMe && (
							<span className={styles.rememberMe}>
								<input
									id='page_remember-me_n/a_checkbox_n/a'
									checked={state.rememberMe}
									className={styles.checkboxInput}
									type="checkbox"
									onChange={() => dispatch({ type: 'TOGGLE_REMEMBER_USER' })}
								/>
								<label
									htmlFor='page_remember-me_n/a_checkbox_n/a'
									id='page_remember-me_n/a_text_n/a'
								>
									{t('loginForm.rememberMe')}
								</label>
							</span>
						)}
						{showForgotPassword && forgotPasswordLink && (
							<a
								target="_top"
								href={forgotPasswordLink}
								className={styles.forgotPasswordLink}
							>
								<button
									id='page_pw-forgotten_n/a_text_'
									className={styles.forgotPassword}
								>
									{t('loginForm.forgotPassword')}
								</button>

							</a>
						)}
						{showForgotPassword && !forgotPasswordLink && (
							<button
								id='page_pw-forgotten_n/a_text_'
								className={styles.forgotPassword}
								onClick={() => dispatch({ type: 'SHOW_FORGOTPW_OVERLAY' })}
							>
								{t('loginForm.forgotPassword')}
							</button>
						)}
					</span>
				</div>
			</div>
			{!showExtendedOnSmallScreens && (
				<button
					className={`${styles.alreadyRegistered} ${showExtendedOnSmallScreens ? styles.arrowOpened : ''}`}
					onClick={() => setShowExtendedOnSmallScreens(!showExtendedOnSmallScreens)}
				>
					{t('loginForm.alreadyRegistered')}
				</button>
			)}
			{showPassfForgottenOverlay && (
				<Modal
					title={t('passwordForgotten.enterPassword.title')}
					isShownAsOverlay
					hasCloseButton
					closeCallback={ () => dispatch({ type: 'HIDE_FORGOTPW_OVERLAY' }) }
					closeButtonId="pop-up_pw-forgotten_start-process_x_close"
					shouldCloseByClickOutside={onelpsParams.forgotPasswordOverlay?.closeByClickOutside}
				>
					<PasswordForgottenStepOne
						onSuccessCallback={ () => {
							if (!onelpsParams.loginForm.showSuccessMessageInForgotPasswordOverlay) {
								dispatch({ type: 'HIDE_FORGOTPW_OVERLAY' });
							}
						}}
						showSuccessMessageInModal={onelpsParams.loginForm.showSuccessMessageInForgotPasswordOverlay}
					/>
				</Modal>
			)}
		</div>
	);
}

ExtendedLogin.propTypes = {
	handleIppLinkClick: PropTypes.func,
	showExtendedByDefault: PropTypes.bool,
	showRememberMe: PropTypes.bool,
	showForgotPassword: PropTypes.bool,
	isTabbed: PropTypes.bool,
	formWrapperClassName: PropTypes.string,
	forgotPasswordLink: PropTypes.string || null,
};

const EnhancedExtendedLogin =
withIppButtons(
	ExtendedLogin
);

export default EnhancedExtendedLogin;
